import React, { Component, useRef } from "react";


import CompletedCourseBody from "./CompletedCourseBody";

import CertificationBody from "./CertificationBody";
import { GET_STUDENT_PORTFOLIO, PRINT_STUDENT_PORTFOLIO } from '../../Queries/Queries';
import { useApolloClient, useQuery, useLazyQuery } from  "@apollo/react-hooks";
import TransitionExpand from "./TransitionExpand.js";
import Workroles from "./Workroles";
import Certifications from "./Certifications";
import CompletedCourses from "./CompletedCourses";
import WorkroleBody from "./WorkroleBody";
import classes from "./index.css";
import _ from 'lodash';
import PortalAppbar from '@chiron/appbar';
import { useReactToPrint } from 'react-to-print';
import Button from '@material-ui/core/Button';
import LoadingSpinner from "./LoadingSpinner";
//import ABigOfData from "../../ABigOfData";
export default function ThePortfolioWrapper(){
    const printableRef = useRef();
    const {loading, error, data} = useQuery(GET_STUDENT_PORTFOLIO, {fetchPolicy: "network-only"});
    const [printPortfolio, {data: portfolioPrint}] = useLazyQuery(PRINT_STUDENT_PORTFOLIO, {skip: true, fetchPolicy: 'no-cache'});
    // console.log('test data from api');
    // console.log({loading,error,data});
    var mydata = null;
    var workroles={}
    var wrraw = null;
    var certraw = null;
    var certs = {};
    var courses = {}
    var crsraw = null;
    var activityshowlist = {};
    var showActivities={};
    var showCompetencies={};
    var showCompActivities={};
    var showKSAT={};
    var showGrades={};
    var savedChildData={};
    if(data && data.moodle && data.moodle.studentPortfolio){
        mydata = JSON.parse(data.moodle.studentPortfolio);
        // console.log('my data');
        // console.log(mydata);
        //mydata = ABigOfData;//JSON.parse(data.moodle.studentPortfolio);
        wrraw = mydata && mydata.workroles ? mydata.workroles : null;
        certraw = mydata && mydata.certs ? mydata.certs : null;
        crsraw = mydata && mydata.courses ? mydata.courses : null;
        Object.keys(wrraw).forEach(wrid => {
        
            var wr = mydata.workroles[wrid]
            wr['hidden']=true
            wr['name']=wr.workrole.name
            wr['id']=wr.workrole.id
            workroles[wrid]=wr
        });
        Object.keys(certraw).forEach(certid => {
            var cert=certraw[certid]
            cert['hidden']=true
            certs[certid]=cert
        })
        Object.keys(crsraw).forEach(crsid => {
            activityshowlist[crsid]={}
            showActivities[crsid]=false
            showCompetencies[crsid]=false
            showCompActivities[crsid]={}
            showGrades[crsid]=false
            showKSAT[crsid]={K:false,S:false,A:false, T:false}
            var course=mydata.courses[crsid]
            course['hidden']=true
            course['id']=crsid
            course['name']=crsraw[crsid].course.fullname
            Object.keys(course.activities).forEach(actid => {
                course.activities[actid]['hidden']=true
                course.activities[actid].competencies.forEach(compid => activityshowlist[crsid][compid]=0)
                
            })
            Object.keys(course.competencies).forEach(compidx => {
                var compid=course.competencies[compidx]
                showCompActivities[crsid][compid]=false
            })
            courses[crsid]=course
        })
    }


    const handlePrint = 
      useReactToPrint({
        content: () => printableRef.current
      });
    // console.log(printableRef);
    // console.log({mydata: mydata, workroles: workroles})
    var badData = mydata && mydata.workroles.length <=0 && mydata.certs.length <=0 && mydata.competencies.length <=0 && mydata.courses.length <=0;
    
    return(
        <div>
          
          <PortalAppbar
                        header={'Chiron Portfolio'}
                    />
            {mydata ? (
              <> 
              {!badData ? ( 
                <>
                <div
                  
                  className={classes.printButtonContainer}
                  >
                  <Button 
                    className={classes.printButton}
                    onClick={() => { printPortfolio(); handlePrint()}}> <i className="fas fa-print"></i></Button>
                  
                </div>

                <ThePortfolio 
                    ref={printableRef}
                    mydata={mydata} 
                    workroles={workroles} 
                    courses={courses}
                    certs={certs}
                    showActivities={showActivities}
                    showCompetencies={showCompetencies}
                    showCompActivities={showCompActivities}
                    activityshowlist={activityshowlist}
                    showKSAT={showKSAT}
                    showGrades={showGrades}
                    savedChildData={savedChildData}/>
                  </>
              ): <div><h3>No data found for current user</h3></div>} 
              </>
              ) : <LoadingSpinner/>}
        </div>
    )
}
class ThePortfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      portfolio: props.mydata,
      workroles: props.workroles,
      certs: props.certs,
      courses: props.courses,
      competencies: props.mydata.competencies,
      showWorkroles: true,
      showCerts: true,
      showCourses: true,
      showActivities: props.showActivities,
      showCompetencies: props.showCompetencies,
      showCompActivities: props.showCompActivities,
      activityshowlist: props.activityshowlist,
      showKSAT: props.showKSAT,
      showGrades: props.showGrades,
      savedChildData: props.savedChildData
    };
    this.ToggleWorkroles = this.ToggleWorkroles.bind(this);
    this.ToggleCerts = this.ToggleCerts.bind(this);
    this.ToggleCourses = this.ToggleCourses.bind(this);
    this.ToggleHideWorkroles = this.ToggleHideWorkroles.bind(this);
    this.ToggleHideCourses = this.ToggleHideCourses.bind(this);
    this.toggleActivityRollup = this.toggleActivityRollup.bind(this);
    this.setActivityCompShowList = this.setActivityCompShowList.bind(this);
    this.toggleShowActivities = this.toggleShowActivities.bind(this);
    this.toggleShowCourseCompetencies = this.toggleShowCourseCompetencies.bind(this);
    this.toggleShowKSAT = this.toggleShowKSAT.bind(this);
    this.toggleShowCompActivities = this.toggleShowCompActivities.bind(this);
    this.toggleShowGrades = this.toggleShowGrades.bind(this);
    this.saveChildData = this.saveChildData.bind(this);
    
    // console.log('component state');
    // console.log(this.state);
  }

  static propTypes = {};
  static defaultProps = {};

  ToggleWorkroles() {
    this.setState({
      showWorkroles: !this.state.showWorkroles
    });

    if (this.state.showWorkroles && window.event.ctrlKey) {
      this.setState({
        showCerts: (this.showCourses = false)
      });
    }
  }

  ToggleCerts() {
    this.setState({
      showCerts: !this.state.showCerts
    });

    if (this.state.showCerts && window.event.ctrlKey) {
      this.setState({
        showWorkroles: (this.showCourses = false)
      });
    }
  }

  ToggleCourses() {
    this.setState({
      showCourses: !this.state.showCourses
    });

    if (this.state.showCourses && window.event.ctrlKey) {
      this.setState({
        showCerts: (this.showWorkroles = false)
      });
    }
  }

  ToggleHideWorkroles(wrid) {
    //this.state.workroles[wrid].hidden = !this.state.workroles[wrid].hidden;
    var tempWorkroles = this.state.workroles;
    tempWorkroles[wrid].hidden = !tempWorkroles[wrid].hidden;
    this.setState({
        workroles: tempWorkroles
    });
    if (window.event.ctrlKey && this.state.workroles[wrid].hidden) {
        Object.keys(tempWorkroles).forEach(owrid => {
            if (owrid != wrid) {
                tempWorkroles[owrid].hidden = true;
            }
        });
        this.setState({workroles:tempWorkroles})
    }
  }

  ToggleHideCourses(crsid) {
    var tempcourselist = _.cloneDeep(this.state.courses);
    // console.log('tempcourselist')
    // console.log(tempcourselist)
    if (window.event.ctrlKey && this.state.courses[crsid].hidden) {
      Object.keys(tempcourselist).forEach(ocrsid => {
        if (ocrsid != crsid) {
          tempcourselist[ocrsid].hidden = true;
        }
      });
    }

    tempcourselist[crsid].hidden = !tempcourselist[crsid].hidden;
    this.setState({courses: tempcourselist});
  }

  toggleActivityRollup(activity) {
    // console.log('courses & activity');
    // console.log({courses: this.state.courses, activity: activity})
    //activity.hidden = !activity.hidden
    var boolVal = this.state.courses[activity.crsid].activities[activity.actid]
      .hidden;
    var tempCrses = this.state.courses;
    tempCrses[activity.crsid].activities[
      activity.actid
    ].hidden = !boolVal;
    this.setState({courses: tempCrses});
  }

  setActivityCompShowList(actcomp, crsid) {
    // console.log({actcomp:actcomp, crsid: crsid})
    var compid = actcomp["compid"];
    var actid = actcomp["activityid"];
    var tempActShowList = {...this.state.activityshowlist};
    if (window.event.ctrlKey) {
      Object.keys(tempActShowList[crsid]).forEach(idx => {
        if (idx != compid && tempActShowList[crsid][idx] == actid) {
          tempActShowList[crsid][idx] = 0;
        }
      });
    }

    if (tempActShowList[crsid][compid] == actid) {
      tempActShowList[crsid][compid] = 0;
    } else {
      tempActShowList[crsid][compid] = actid;
    }

    this.setState({activityshowlist: tempActShowList});
  }

  toggleShowActivities(crsid) {
    if (!window.event.ctrlKey) {
      Object.keys(this.state.courses[crsid].activities).forEach(actid => {
        this.state.courses[crsid].activities[
          actid
        ].hidden = this.state.showActivities[crsid];
      });
    }

    var showActivitiez = this.state.showActivities;
    showActivitiez[crsid] = !this.state.showActivities[crsid];
    this.setState({showActivities: showActivitiez})
  }

  toggleShowCourseCompetencies(crsid) {
    //if(!window.event.ctrlKey){
    //Object.keys(this.courses[crsid].activities).forEach(actid =>{
    //this.courses[crsid].activities[actid].hidden=this.showActivities[crsid]
    //})
    //}
    var tempshowComp = _.cloneDeep(this.state.showCompetencies);
    tempshowComp[crsid] = !tempshowComp[crsid];
    this.setState({showCompetencies: tempshowComp})
    //this.state.showCompetencies[crsid] = !this.state.showCompetencies[crsid];
  }

  toggleShowKSAT(crsid, ksat) {
    //if(!window.event.ctrlKey){
    //Object.keys(this.courses[crsid].activities).forEach(actid =>{
    //this.courses[crsid].activities[actid].hidden=this.showActivities[crsid]
    //})
    //}
    var showksat = this.state.showKSAT;

    showksat[crsid][ksat] = !this.state.showKSAT[crsid][ksat];
    this.setState({showKSAT: showksat});
  }

  toggleShowCompActivities(compid, crsid) {
    // console.log({compid: compid, crsid:crsid})
    //if(!window.event.ctrlKey){
    //Object.keys(this.courses[crsid].activities).forEach(actid =>{
    //this.courses[crsid].activities[actid].hidden=this.showActivities[crsid]
    //})
    //}
    var showCompActivitiez = this.state.showCompActivities;

    showCompActivitiez[crsid][compid] = !this.state
      .showCompActivities[crsid][compid];

    this.setState({showCompActivities: showCompActivitiez});

  }

  toggleShowGrades(crsid) {
    var showGradez = this.state.showGrades;

    showGradez[crsid] = !this.state.showGrades[crsid];
    this.setState({showGrades: showGradez});
  }

  saveChildData(stuff, key) {
    this.state.savedChildData[key] = stuff;
    let jsondata = JSON.stringify(this.state.savedChildData);
    sessionStorage.setItem("savedChildData", jsondata);
  }

  render() {
    const {
      showWorkroles,
      showCerts,
      showCourses,
      workroles,
      competencies,
      courses,
      certs,
      activityshowlist,
      showActivities,
      showCompetencies,
      showCompActivities,
      showKSAT,
      showGrades,
      savedChildData
    } = this.state;
    return (
        <div className={classes.chironPortfolio}>
          <div className={classes.chironPortfolioSections}>
            <Workroles showSect={showWorkroles} toggleWrkroles={this.ToggleWorkroles} key={"Workroles"}></Workroles>
            <Certifications
                showSect={showCerts}
                toggleCerts={this.ToggleCerts}
                key={"Certifications"}
            ></Certifications>
            <CompletedCourses
                showSect={showCourses}
                toggleCourses={this.ToggleCourses}
                key={"CompletedCourses"}
            ></CompletedCourses>
            <TransitionExpand duration={500} height={showWorkroles ? 'auto' : 0}>
                {showWorkroles && (
                <WorkroleBody
                    workroles={workroles}
                    fullcomplist={competencies}
                    courses={courses}
                    allcerts={certs}
                    competencies={competencies}
                    parentSaved={savedChildData["WorkroleBody"]}
                    className={classes.fullwidth}
                    key={showWorkroles}
                    toggleHide={this.ToggleHideWorkroles}
                ></WorkroleBody>
                )}
          </TransitionExpand>
          <TransitionExpand duration={500} height={showCerts ? 'auto' : 0}>
            {showCerts && (
              <CertificationBody
                className={classes.fullwidth}
                certs={certs}
                fullcomplist={competencies}

              />
            )}
          </TransitionExpand>
          <TransitionExpand duration={500} height={showCourses ? 'auto' : 0}>
            {showCourses && (
              <CompletedCourseBody
                className={classes.fullwidth}
                courses={courses}
                fullcomplist={competencies}
                activityshowlist={activityshowlist}
                showActivities={showActivities}
                showCompetencies={showCompetencies}
                showCompActivities={showCompActivities}
                showKSAT={showKSAT}
                showGrades={showGrades}
                toggleHide={this.ToggleHideCourses}
                toggleHideActivityRollup={this.toggleActivityRollup}
                setActivityCompShowList={this.setActivityCompShowList}
                toggleShowActivities={this.toggleShowActivities}
                toggleShowCompetencies={this.toggleShowCourseCompetencies}
                toggleShowCompActivities={this.toggleShowCompActivities}
                toggleShowKsat={this.toggleShowKSAT}
                toggleShowGrades={this.toggleShowGrades}
                //@save-please="saveChildData($event, 'CompletedCourseBody')"
                //:parentSaved="savedChildData['CompletedCourseBody']"

              />
            )}
          </TransitionExpand>
          </div>
        </div>
      );
    /*
    return (
      <div className="chiron-portfolio">
        <h1>Chiron Portfolio for {fullname}</h1>
        <div className="chiron-portfolio-sections">
          <Workroles showSect={showWorkroles} toggleWrkroles={() => ToggleWorkroles} key={"Workroles"}></Workroles>
          <Certifications
            showSect={showCerts}
            key={"Certifications"}
          ></Certifications>
          <CompletedCourses
            showSect={showCourses}
            key={"CompletedCourses"}
          ></CompletedCourses>
          <TransitionExpand name="slide">
            {showWorkroles && (
              <WorkroleBody
                workroles={workroles}
                fullcomplist={competencies}
                courses={courses}
                allcerts={certs}
                competencies={competencies}
                parentSaved={savedChildData["WorkroleBody"]}
                className="fullwidth"
                key={showWorkroles}
              ></WorkroleBody>
            )}
          </TransitionExpand>
          <TransitionExpand name="slide">
            {showCerts && (
              <CertificationBody
                certs={certs}
                fullcomplist={competencies}
                className="fullwidth"
                key={showCerts}
              ></CertificationBody>
            )}
          </TransitionExpand>
          <TransitionExpand name="slide">
            {showCourses && (
              <CompletedCourseBody
                courses={courses}
                fullcomplist={competencies}
                activityshowlist={activityshowlist}
                showActivities={showActivities}
                showCompetencies={showCompetencies}
                showCompActivities={showCompActivities}
                showKSAT={showKSAT}
                showGrades={showGrades}
                parentSaved={savedChildData["CompletedCourseBody"]}
                className="fullwidth"
                key={showCourses}
              ></CompletedCourseBody>
            )}
          </TransitionExpand>
        </div>
      </div>
    );
    */
  }
}
